import Api from '@teko/api';
import { logger } from '@teko/log';
import tekoOAuth from 'teko-oauth2';
import { accessTokenInterceptor, handleResponseUnauthorizedInterceptor } from './interceptor.es.js';
import { jwtDecode } from './jwt.es.js';
import { userManager } from './user.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
let tekoOAuthPromise = null;
const IAM_ERRORS_MAP = {
  "1019": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c",
  "1020": "\u0110\u1ECBa ch\u1EC9 email \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c.",
  "1021": "\u0110\u1ECBa ch\u1EC9 email kh\xE1c \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho t\xE0i kho\u1EA3n n\xE0y",
  "1040": "M\xE3 OTP kh\xF4ng ch\xEDnh x\xE1c",
  "1015": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xF4ng h\u1EE3p l\u1EC7",
  "1800": "\u0110\xE3 g\u1EEDi qu\xE1 nhi\u1EC1u y\xEAu c\u1EA7u, vui l\xF2ng quay l\u1EA1i sau"
};
class AuthService {
  constructor(iamUrl, iamClientId, iamOauthDomain) {
    this.initialize = async (scopes) => {
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        if (!tekoOAuthPromise) {
          tekoOAuthPromise = tekoOAuth.init({
            clientId: this.iamClientId,
            scopes,
            oauthDomain: this.iamOauthDomain,
            postLogoutRedirectUri: window.location.origin
          });
        }
        return tekoOAuthPromise.then(() => {
          var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
          tekoOAuthPromise = null;
          (_d = (_c = (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.events) == null ? void 0 : _c.addSilentRenewError) == null ? void 0 : _d.call(_c, (err) => {
            var _a2;
            window.track("customEvent", "silentRenewError", {
              action: "silentRenew",
              category: "customer",
              label: JSON.stringify({
                message: err == null ? void 0 : err.message,
                stack: err == null ? void 0 : err.stack
              }),
              property: "tekoid-js"
            });
            (_a2 = this.tekoID.user) == null ? void 0 : _a2.loginSilent().catch((retryErr) => {
              logger.error(retryErr);
            });
          });
          (_g = (_f = (_e = this.tekoID) == null ? void 0 : _e.user) == null ? void 0 : _f.events) == null ? void 0 : _g.addAccessTokenExpiring(() => {
            window.track("customEvent", "accessTokenExpiring", {
              action: "accessTokenExpiring",
              category: "customer",
              property: "tekoid-js"
            });
          });
          (_j = (_i = (_h = this.tekoID) == null ? void 0 : _h.user) == null ? void 0 : _i.events) == null ? void 0 : _j.addAccessTokenExpired(() => {
            window.track("customEvent", "accessTokenExpired", {
              action: "silentRenew",
              category: "customer",
              property: "tekoid-js"
            });
          });
        }).catch((error) => {
          logger.error(error);
          tekoOAuthPromise = null;
        });
      } else {
        return Promise.resolve();
      }
    };
    this.requestLogin = async (challenge) => {
      try {
        const { data } = await this.authApi.get(`/v1/requests/login/${challenge}`, {});
        return data;
      } catch (er) {
        logger.error(er);
        if (typeof window !== "undefined")
          window.location.href = "/";
      }
    };
    this.login = (redirectUrl) => {
      var _a, _b;
      (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.login(redirectUrl || (window.location.pathname === "/" ? void 0 : window.location.href));
    };
    this.logout = (redirectUrl) => {
      var _a, _b;
      (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.logout(redirectUrl);
      userManager.onLoggedOut();
    };
    this.requestLogout = async (challenge) => {
      const {
        data: { redirect_to: redirectTo }
      } = await this.authApi.post(`/v1/requests/logout/${challenge}`, {
        challenge,
        confirmed: true
      });
      userManager.onLoggedOut();
      if (redirectTo)
        window.location.assign(redirectTo);
    };
    this.loginSocialIAM = async (challenge, accessToken, authorizer) => {
      return await this.authApi.post("/v1/social/login", {
        challenge,
        access_token: accessToken,
        authorizer
      });
    };
    this.sendOTP = async (challenge, phone, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/passwordless/send", __spreadValues({
        challenge,
        phone_number: phone,
        client_id: this.iamClientId
      }, recaptchaToken && { recaptcha_token: recaptchaToken }));
      return data;
    };
    this.sendOTPUpdatePhone = async (phone, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/verify", __spreadValues({
        phone_number: phone
      }, recaptchaToken && { recaptcha_token: recaptchaToken }));
      return data;
    };
    this.register = async ({
      phone,
      name,
      password,
      recaptchaToken
    }) => {
      const { data } = await this.authApi.post(`/v1/users/register`, __spreadProps(__spreadValues({
        username: phone,
        password: password || Math.random().toString(36).slice(-16),
        name
      }, recaptchaToken && { recaptcha_token: recaptchaToken }), {
        client_id: this.iamClientId
      }));
      return data;
    };
    this.loginIAMWithPhone = async (challenge, phone, otp) => {
      const { data } = await this.authApi.post("/v1/passwordless/login", {
        challenge,
        phone_number: phone,
        code: otp
      });
      return data;
    };
    this.activeIAMPhoneAccount = async (challenge, phone, otp) => {
      const { data } = await this.authApi.post("/v1/users/confirm", {
        challenge,
        username: phone,
        code: otp,
        client_id: this.iamClientId
      });
      return data;
    };
    this.resendOTP = async (phone, mode, challenge = "", recaptchaToken) => {
      if (mode === "login")
        return await this.sendOTP(challenge, phone, recaptchaToken);
      const { data } = await this.authApi.post("/v1/users/activation/resend", {
        username: phone,
        client_id: this.iamClientId,
        recaptcha_token: recaptchaToken
      });
      return data;
    };
    this.refreshToken = async (refreshToken) => {
      const queries = `grant_type=refresh_token&client_id=${this.iamClientId}&refresh_token=${refreshToken}`;
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      userManager.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub
      });
      return responseData;
    };
    this.loginWithFederation = async (idToken, authorizer) => {
      const queries = `grant_type=federated_idp&client_id=${this.iamClientId}&jwt_token=${idToken}&authorizer=${authorizer}&scope=openid profile read:permissions us ps ppm om`;
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      userManager.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub
      });
      return responseData;
    };
    this.loginWithIBanking = async (data) => {
      const { partner_code } = data;
      let queries = `grant_type=ibanking&client_id=${this.iamClientId}&data=${data.data}&signature=${data.signature}&scope=openid profile read:permissions us ps ppm om`;
      if (partner_code) {
        queries = `${queries}&partner_code=${partner_code}`;
      }
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      const { ibanking_info } = responseData;
      userManager.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub,
        bankCode: ibanking_info == null ? void 0 : ibanking_info.bankcode,
        phone: ibanking_info == null ? void 0 : ibanking_info.mobile
      });
      return responseData;
    };
    this.loginWithTerra = (loginInfo) => {
      userManager.onPartnerLoggedIn({
        userId: loginInfo.userId,
        name: loginInfo.name,
        accessToken: loginInfo.accessToken,
        phone: loginInfo.phone,
        picture: loginInfo.picture,
        email: loginInfo.email
      });
      return userManager.getLSInfo();
    };
    this.getLoginInfo = () => {
      return userManager.getInfo();
    };
    this.isLoggedIn = () => {
      return !!userManager.getAccessToken();
    };
    this.verifyPhone = async (phoneNumber) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/verify", {
        phone_number: phoneNumber
      });
      return data;
    };
    this.verifyEmail = async (email) => {
      const { data } = await this.authApi.post("/v1/me/email/verify", { email });
      return data;
    };
    this.updatePhone = async (phoneNumber, otp) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/update", {
        phone_number: phoneNumber,
        code: otp
      });
      return data;
    };
    this.updateEmail = async (email, otp) => {
      const { data } = await this.authApi.post("/v1/me/email/update", {
        email,
        code: otp
      });
      return data;
    };
    this.errorMsg = (err) => {
      var _a;
      const errorCode = typeof err === "string" ? err : (_a = err == null ? void 0 : err.error) == null ? void 0 : _a.code;
      return IAM_ERRORS_MAP[errorCode];
    };
    this.loginWithPassword = async ({
      challenge,
      phone,
      password,
      recaptchaToken
    }) => {
      const { data } = await this.authApi.post("/v1/users/login", __spreadProps(__spreadValues({
        challenge,
        username: phone,
        password
      }, recaptchaToken && { recaptcha_token: recaptchaToken }), {
        client_id: this.iamClientId
      }));
      return data;
    };
    this.recoverPassword = async (phone, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/password/recover", {
        username: phone,
        recaptcha_token: recaptchaToken,
        client_id: this.iamClientId
      });
      return data;
    };
    this.resetPassword = async (phone, password, otp, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/password/reset", {
        username: phone,
        password,
        code: otp,
        recaptcha_token: recaptchaToken,
        client_id: this.iamClientId
      });
      return data;
    };
    this.iamUrl = iamUrl;
    this.iamClientId = iamClientId;
    this.iamOauthDomain = iamOauthDomain;
    this.authApi = new Api(iamUrl, (error) => error);
    this.authApi.addInterceptor(accessTokenInterceptor);
    this.authApi.addResponseInterceptor(handleResponseUnauthorizedInterceptor);
  }
  get tekoID() {
    return window.TekoID;
  }
}

export { AuthService };
